import { MARKETING_HOME_CHARGES } from '@/content/marketing/home-mock-data';
import { useAuthHydration } from '@/hooks/use-auth-hydration';
import { isMarketingMockEnabled } from '@/lib/marketing-mock/is-marketing-mock-enabled';
import { getMarketingMockQueryOptions } from '@/lib/marketing-mock/query-options';
import api from '@/services/api';
import { Charge } from '@/types/charge';
import { useQuery } from '@tanstack/react-query';
import { chargeKeys } from './use-charges';

export function useRecentCharges(limit: number = 10) {
  const isHydrated = useAuthHydration();

  return useQuery({
    queryKey: [...chargeKeys.all, 'recent', limit],
    queryFn: async () => {
      // Busca apenas cobranças do prestador logado, usando a rota de provider
      const response = await api.get<{
        data: Charge[];
        total: number;
        page: number;
        limit: number;
      }>('/provider/charges', {
        params: {
          page: 1,
          limit,
        },
      });

      const charges = response.data.data || [];

      // Garante ordenação por data de criação (mais recentes primeiro), caso o backend mude
      const sorted = charges.sort((a, b) => {
        const dateA = new Date(a.createdAt).getTime();
        const dateB = new Date(b.createdAt).getTime();
        return dateB - dateA;
      });

      return sorted.slice(0, limit);
    },
    enabled: isHydrated,
    ...getMarketingMockQueryOptions(
      isMarketingMockEnabled() ? MARKETING_HOME_CHARGES.slice(0, limit) : undefined,
    ),
  });
}
